export var getTextFromHtml = function getTextFromHtml(str) {
  // Избежать краша если будет undefined
  if (typeof str !== 'string') {
    return '';
  }
  var regex = /(&nbsp;| |<([^>]+)>)/gi;
  return str.replace(regex, ' ').trim();
};